(function () {
  'use strict';
  function syncClampToggleState(clamp, toggle, expanded) {
    if (!clamp || !toggle) return;
    clamp.setAttribute('data-expanded', expanded ? 'true' : 'false');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Show less' : 'Read more';
  }
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.itmart24-compare-cell-clamp__toggle');
    if (!toggle) return;
    const clamp = toggle.closest('.itmart24-compare-cell-clamp');
    if (!clamp) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const expanded = clamp.getAttribute('data-expanded') === 'true';
    syncClampToggleState(clamp, toggle, !expanded);
  }, true);
})();